import Vue from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

Vue.component('back-button', {

    data() {
        return {
        };
    },

    mounted() {
        this.initBack();
    },

    methods: {
        initBack() {
            ScrollTrigger.create({
                trigger: '#container-2',
                start: 'bottom top+=100px',
                endTrigger: "#intro-text",
                end: "bottom 50%",
                toggleClass: {targets: ".work__back-link", className: "active"}
               
            });

            ScrollTrigger.create({
                trigger: '#intro-text',
                start: 'top 50%',
                endTrigger: "#page-wrapper",
                toggleClass: {targets: ".work__back-link", className: "hidden"}
            });
        },
    },
});